import { iconStyles } from 'components/Shared/Icon/iconStyles';
import { IconProps } from 'components/Shared/Icon/index';

type Thickness = 'thin' | 'thick';
export const IconArrow = (props: IconProps & { thickness?: Thickness }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 378 792" className={iconStyles(props)}>
    <path d="M0 792l244-396L0 0h134l244 396-244 396z" />
  </svg>
);
